import React from 'react'

const SmsDurumBadge = ({ text }) => {
  const selectColor = (text) => {
    switch (text) {
      case 'Başarısız':
        return '#D62D1A'
      case 'İletildi':
        return '#15AC3D'
      case 'Geçersiz Numara':
        return '#D62D1A'

      default:
        return '#787878'
    }
  }
  return (
    <div
      style={{
        color: '#fff',
        padding:'0 .7rem .1rem .7rem',
        borderRadius: '15px',
        backgroundColor: selectColor(text),
      }}
    >
      {text}
    </div>
  )
}

export default SmsDurumBadge
